export const formPersonalValues = (data = {}) => ({
  Customer_code: data?.customer_code ?? data ?? "",
  Customer_name: data?.customer_name ?? "",
  Customer_Foto: data?.foto ?? ""
});
  